/* tslint:disable */
import { loadStyles } from '@microsoft/load-themed-styles';

loadStyles([{"rawString":".ms-dialogMainOverride{max-width:450px}"}]);
/* tslint:enable */